import React from "react";

import placeholder from "../../assets/placeholder.png";
import { BsTwitter, BsInstagram } from "react-icons/bs";
import { AiFillInstagram } from "react-icons/ai";
import { SiLinktree } from "react-icons/si";
function TeamSection(props) {
  return (
    <div className="grid md:gap-10 lg:px-10 grid-cols-1 md:grid-cols-2 ">
      <div className="flex flex-col lg:px-10 px-10 md:px-0 lg:pr-20 mb-10 ">
        <div className="w-full flex flex-col">
          <div className="w-full ">
            <p className="text-white pb-5  text-xl tracking-tight letter-spacing:-0.05em lg:text-[33px]">
              {props.name1}{" "}
              <span className="text-[#747397] text-sm lg:text-[18px] tracking-tight letter-spacing:-0.05em font-[300]">
                {props.subtitle1}
              </span>
            </p>
          </div>{" "}
          <img src={props.picture1} className="w-full h-full" alt="" />
        </div>
        <div className="flex mt-5 align-start w-2/3 ">
          {props.twitter ? (
            <a href={`https://twitter.com/${props.twitterLink1}`}>
              <BsTwitter
                size={30}
                className="bg-[#646AFB] rounded-sm p-1 text-white mr-2 mt-2 mb-2"
              />
            </a>
          ) : null}
          {props.insta ? (
            <a href={`https://instagram.com/${props.instaLink1}`}>
              <AiFillInstagram
                size={30}
                className="bg-[#646AFB] rounded-sm p-1 text-white mr-2 mt-2 mb-2"
              />
            </a>
          ) : null}
        </div>
      </div>

      {props.name2 && (
        <div className="flex flex-col lg:pl-20 lg:px-10 px-10 md:px-0 mb-10">
          <div className="w-full flex flex-col">
            <div className="w-full ">
              <p className="text-white pb-5 tracking-tight letter-spacing:-0.05em  md:text-xl lg:text-[33px]">
                {props.name2}{" "}
                <span className="text-[#747397] tracking-tight letter-spacing:-0.05em text-sm lg:text-[18px] font-[300]">
                  {props.subtitle2}
                </span>
              </p>
            </div>{" "}
            <img
              src={props.picture2}
              className="w-full h-full rounded-md"
              alt=""
            />
          </div>
          <div className="flex mt-5 align-start w-2/3 ">
            {props.oneLink ? (
              <a href={`https://linktr.ee/Ai_dezign`}>
                <SiLinktree
                  size={30}
                  className="bg-[#646AFB] rounded-sm p-1 text-white mr-2 mt-2 mb-2"
                />
              </a>
            ) : (
              <div className="flex mt-5 align-start w-2/3 ">
                {props.twitter2 ? (
                  <a href={`https://twitter.com/${props.twitterLink2}`}>
                    <BsTwitter
                      size={30}
                      className="bg-[#646AFB] rounded-sm p-1 text-white mr-2 mt-2 mb-2"
                    />
                  </a>
                ) : null}
                {props.insta2 ? (
                  <a href={`https://instagram.com/${props.instaLink2}`}>
                    <AiFillInstagram
                      size={30}
                      className="bg-[#646AFB] rounded-sm p-1 text-white mr-2 mt-2 mb-2"
                    />
                  </a>
                ) : null}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default TeamSection;
